/* ATN Global Intelligence - news filter
   Sorts the rendered article cards newest first, caps how many are visible,
   and filters them by blog handle when a pill is clicked. No network calls:
   every card is already in the DOM, this only shows and hides them. */
(function () {
  'use strict';

  function setup(root) {
    if (root.dataset.atnGiNewsReady === 'true') return;
    root.dataset.atnGiNewsReady = 'true';

    var grid = root.querySelector('[data-gin-grid]');
    if (!grid) return;

    var items = Array.prototype.slice.call(grid.querySelectorAll('[data-gin-item]'));
    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-gin-filter]'));
    var visible = parseInt(grid.getAttribute('data-gin-visible'), 10);
    if (isNaN(visible) || visible < 1) visible = 5;

    var follow = grid.getAttribute('data-gin-follow') !== 'false';
    var viewAll = root.querySelector('[data-gin-viewall]');
    var viewAllLabel = root.querySelector('[data-gin-viewall-label]');
    var viewAllHref = viewAll ? viewAll.getAttribute('href') : null;
    var viewAllText = viewAllLabel ? viewAllLabel.textContent : '';

    function syncViewAll(pill) {
      if (!follow || !viewAll) return;
      var url = pill && pill.getAttribute('data-gin-url');
      var label = pill && pill.getAttribute('data-gin-label');
      viewAll.setAttribute('href', url || viewAllHref || '#');
      if (viewAllLabel) viewAllLabel.textContent = label || viewAllText;
    }

    // Newest first, across every blog.
    items
      .slice()
      .sort(function (a, b) {
        return (
          parseInt(b.getAttribute('data-gin-date'), 10) -
          parseInt(a.getAttribute('data-gin-date'), 10)
        );
      })
      .forEach(function (el) {
        grid.appendChild(el);
      });

    function apply(filter) {
      var shown = 0;
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var match = filter === 'all' || el.getAttribute('data-gin-cat') === filter;
        if (match && shown < visible) {
          el.hidden = false;
          shown++;
        } else {
          el.hidden = true;
        }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) {
          p.classList.toggle('is-active', p === pill);
        });
        apply(pill.getAttribute('data-gin-filter'));
        syncViewAll(pill);
      });
    });

    var first = root.querySelector('[data-gin-filter].is-active') || pills[0];
    apply(first ? first.getAttribute('data-gin-filter') : 'all');
    syncViewAll(first);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.atn-gi-news');
    for (var i = 0; i < roots.length; i++) setup(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();